import { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  Divider,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

interface FormData {
  documentCount: string;
  attachedDocuments: { [key: string]: boolean };
  otherDocument?: string;
}

const permitOptions = [
  {name: "idCard", label: "สำเนาบัตรประจำตัวประชาชน พร้อมรับรองสำเนาถูกต้อง" },
  {name: "license",label: "สำเนาใบอนุญาตประกอบวิชาชีพ พร้อมรับรองสำเนาถูกต้อง",},
  {name: "drugPermit",label:"สำเนาใบอนุญาตขายยาแผนปัจจุบัน (แบบ ข.ย.๕) พร้อมรับรองสำเนาถูกต้อง (ถ้ามี)",},
  {name: "clinicPermit",label:"สำเนาใบอนุญาตให้ดำเนินการสถานพยาบาล (ส.พ.๑๙) พร้อมรับรองสำเนาถูกต้อง (ถ้ามี)",},
  {name: "businessPermit",label:"สำเนาใบอนุญาตให้ประกอบกิจการสถานพยาบาล (แบบ ส.พ.๗) พร้อมรับรองสำเนาถูกต้อง (ถ้ามี)",},
];

const authOptions = [
  {name: "authIdCardGiver",label: "สำเนาบัตรประชาชนผู้มอบอำนาจ พร้อมรับรองสำเนาถูกต้อง",},
  {name: "authIdCardReceiver",label: "สำเนาบัตรประชาชนผู้รับมอบอำนาจ พร้อมรับรองสำเนาถูกต้อง",},
  {name: "authDocument", label: "หนังสือมอบอำนาจ พร้อมติดอากรแสตมป์" },
];

const AttachEvidence = () => {
  const [formData, setFormData] = useState<FormData>({
    documentCount: "",
    attachedDocuments: {
      idCard: false,
      license: false,
      drugPermit: false,
      clinicPermit: false,
      businessPermit: false,
      authorization: false,
      authIdCardGiver: false,
      authIdCardReceiver: false,
      authDocument: false,
      other: false,
      agreement: false,
    },
    otherDocument: "",
  });
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    const storedData = localStorage.getItem("legalEntityInfo");
    if (storedData) {
      try {
        setFormData(JSON.parse(storedData));
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }
  }, []);

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({
      ...prev,
      [name]:
        value === "" &&
        (name !== "otherDocument" || formData.attachedDocuments.other),
    }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({...prev,attachedDocuments: { ...prev.attachedDocuments, [name]: checked },
    }));

    if (name === "other" && !checked) {
      setErrors((prev) => ({ ...prev, otherDocument: false }));
    }
  };

  return (
    <form>
      <Grid container sx={{ mt: 3 }}>
        <Grid item xs={12}>
          <Divider />
        </Grid>
      </Grid>
      {/* ข้อตกลงยินยอมของผู้ประกอบกิจการหน่วยบริการ */}
      <Grid container spacing={1} sx={{ pl: { xs: 0, md: 10 } }}>
        <Grid item xs={12} sx={{ my: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.attachedDocuments.agreement}
                onChange={handleCheckboxChange}
                name="agreement"
              />
            }
            label={
              <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                ข้อตกลงยินยอมของผู้ประกอบกิจการหน่วยบริการ
              </Typography>
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={1} sx={{ pl: { xs: 0, md: 10 } }}>
        <Grid item xs={12} md={10}>
          <Typography variant="body1" sx={{ ml: 4, mt: 2 }}>
            ๑. ข้าพเจ้ารับทราบว่ากระทรวงสาธารณะสุข สำนักงานปลัดกระทรวงสาธารณสุข
            และหน่วยงานของรัฐที่เกี่ยวข้อง มีหน้าที่และอำนาจ
            ตามกฎหมายในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า
            ตามวัตถุประสงค์ของการดำเนินงานตามนโยบาย “ ๓๐ บาทรักษาทุกที่
            ด้วยบัตรประชาชนใบเดียว ”
          </Typography>
          <Typography variant="body1" sx={{ ml: 4, mt: 2 }}>
            ๒.
            ข้าพเจ้ารับทราบและตกลงปฎิบัติตามข้อกำหนดและเงื่อนไขการเชื่อมโยงข้อมูลบริการด้านสาธารณสุข
            ที่กระทรวงสาธารณสุขหรือ สำนักงานปลัดกระทรวงสาธารณสุขกำหนด
            รวมทั้งทราบเงื่อนไขในการให้กระทรวงสาธารณสุข
            สำนักงานปลัดกระทรวงสาธารณสุข หน่วยงานของรัฐที่เกี่ยวข้อง
            และหน่วยบริการอื่น เก็บรวบรวมใช้
            และเปิดเผยข้อมูลส่วนบัคคลที่ข้าพเจ้าได้ให้ไว้ เพื่อประโยชน์ในการ
            ประมวลผลและการตรวจสอบข้อมูลในการเข้าร่วมดำเนินการ ตามนโยบาย “ ๓๐
            บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว ”
            ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. ๒๕๖๒
            และกฎหมายอื่นที่เกี่ยวข้อง
          </Typography>
          <Typography variant="body1" sx={{ ml: 4, mt: 2 }}>
            ๓.
            ข้าพเจ้ารับทราบว่าการนำเข้าข้อมูลสู่ระบบคอมพิวเตอร์ซึ่งข้อมูลอันเป็นเท็จเป็นการกระทำความผิดตามพระราชบัญญัติว่าด้วยการ
            กระทำความผิดเกี่ยวกับคอมพิวเตอร์ พ.ศ.๒๕๕๐
            และที่แก้ไขเพิ่มเติมและกฎหมายอื่นที่เกี่ยวข้อง
          </Typography>
          <Typography variant="body1" sx={{ ml: 4, mt: 2 }}>
            ๔. ข้าพเจ้าขอรับรองว่าข้อมูลดังกล่าวถูกต้องตามความเป็นจริงทุกประการ
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={1} sx={{ pl: { xs: 0, md: 10 }, mt: 10 }}>
        <Grid item xs={12}>
          <Typography>
            *หมายเหตุ : หน่วยบริการฯ สามารถสมัครเข้าร่วมตามนโยบาย “๓๐
            บาทรักษาทุกที่ ด้วยบัตรประชาชนใบเดียว”
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            ผ่านการสมัครโดยตรงกับสำนักงานสาธารณะสุขจังหวัด เท่านั้น
            เนื่องจากต้องมีการตรวจสอบเอกสารประกอบการสมัคร
          </Typography>
        </Grid>
      </Grid>
    </form>
  );
};

export default AttachEvidence;
